const LegendEntries = require('./LegendEntries');

module.exports = LegendEntries;
